import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isStageTab: false,
  stageId: null,
  unique_identifier: null,
  isStageViewOverride: false,
  currentDetailChild: {},
};

const childFunctionalSlice = createSlice({
  name: "childFunctional",
  initialState,
  reducers: {
    setIsStageTab(state, action) {
      state.isStageTab = action.payload;
    },
    setStageId(state, action) {
      state.stageId = action.payload;
      if (action.payload) state.isStageTab = true;
      if (action.payload) state.currentDetailChild = {};
    },
    setIdentifierAndIdentifier(state, action) {
      state.unique_identifier = action.payload.unique_identifier;
      state.stageId = action.payload.stageId;
      if (action.payload) {
        state.isStageTab = true;
      } else {
        state.isStageTab = false;
      }
    },
    setIsStageViewOverride(state, action) {
      state.isStageViewOverride = action.payload;
    },
    setCurrentDetailChild(state, action) {
      state.currentDetailChild = action.payload;
    },
    resetStageTab(state) {
      state.isStageTab = false;
      state.stageId = null;
      state.unique_identifier = null;
    },
  },
});

export const {
  setIdentifierAndIdentifier,
  setStageId,
  setIsStageViewOverride,
  setCurrentDetailChild,
} = childFunctionalSlice.actions;
export default childFunctionalSlice.reducer;
